import React from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/auth/actions";

export default function Navbar() {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    sessionStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f8fafc" }}>
      {/* Sidebar */}
      <aside
        className="sidebar"
        style={{
          width: "240px",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: 1040,
          display: "flex",
          flexDirection: "column",
          background: "linear-gradient(180deg, #ffffff 0%, #f0f5ff 100%)",
          borderRight: "1px solid #e5e7eb",
          padding: "0 16px",
        }}
      >
        {/* Logo */}
        <div
          style={{
            padding: "24px 0",
            borderBottom: "1px solid #e2e8f0",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            <span
              style={{
                fontWeight: 700, // Softer than 800
                fontSize: "22px",
                color: "#2563eb", // Solid blue, easier to read
                letterSpacing: "0.5px",
              }}
            >
              Stellarmind.ai
            </span>
            <p
              style={{
                margin: 0,
                fontSize: "12px",
                marginTop: "4px",
                color: "#334155", // Darker, more readable
                fontWeight: 500,
                letterSpacing: ".5px",
              }}
            >
              Intelligent Control Center
            </p>
          </Link>
        </div>

        {/* Nav Links */}
        <ul style={{ marginTop: "20px", padding: 0, listStyle: "none" }}>
          {[
            { path: "/", label: "Blog" },
            { path: "/career", label: "Career" },
            { path: "/portfolio", label: "Portfolio" },
            { path: "/technologie", label: "Technologies" },
            { path: "/contact", label: "Contact" },
            { path: "/portfolio-sequence", label: "Portfolio Sequence" },
            { path: "/news", label: "News & Events" },
          ].map((item) => {
            const active = location.pathname === item.path;
            return (
              <li key={item.path} style={{ marginBottom: "6px" }}>
                <Link
                  to={item.path}
                  style={{
                    display: "block",
                    padding: "12px 14px",
                    borderRadius: "12px",
                    textDecoration: "none",
                    fontSize: "15px",
                    fontWeight: active ? 600 : 500,
                    color: active ? "#1e3a8a" : "#475569",
                    background: active ? "#e8efff" : "transparent",
                    transition: "all 0.25s ease",
                  }}
                >
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>

        {/* Logout Section */}
        {isAuthenticated && user && (
          <div
            style={{
              marginTop: "auto",
              padding: "20px 0",
              borderTop: "1px solid #e2e8f0",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                color: "#475569",
                marginBottom: "8px",
              }}
            >
              Signed in as
              <span style={{ fontWeight: 600 }}> {user.username}</span>
            </div>

            <span
              onClick={handleLogout}
              style={{
                fontSize: "17px", // Increased font size
                fontWeight: 500,
                cursor: "pointer",
                color: "#ef4444",
                opacity: 0.9,
                transition: "opacity .2s",
              }}
              onMouseEnter={(e) => (e.target.style.opacity = 1)}
              onMouseLeave={(e) => (e.target.style.opacity = 0.9)}
            >
              Logout →
            </span>
          </div>
        )}
      </aside>

      {/* Main Content */}
      <main style={{ marginLeft: "240px", width: "100%" }}>
        <Outlet />
      </main>
    </div>
  );
}
